import { render, staticRenderFns } from "./jadwal_minum.vue?vue&type=template&id=214830c2&"
import script from "./jadwal_minum.vue?vue&type=script&lang=js&"
export * from "./jadwal_minum.vue?vue&type=script&lang=js&"
import style0 from "./jadwal_minum.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports